module.exports = __webpack_public_path__ + "static/img/img_ewm_a.4e747512.png";